export const menuFilter = (items, location = "PRIMARY") => {
  return items?.nodes
    ?.flatMap((item) => item)
    .filter((menuItem) => menuItem?.locations?.includes(location))
    .shift();
};
